import { AxiosError } from "axios";
import { authorizedAxios } from "../../Actions/AxiosActions";
import { IPrintAxios } from "../IPrintAxios";
import { IPdfHtmlData } from "../../Common/Models";

//This is dumb, but it's the only way I can seem to get data back from this request
interface IPdfNewTabResponse {
  url: string;
}

export class PrintAxios implements IPrintAxios {
    public ImageDataUrlsToPdf(
        filenameNoExtension: string,
        dataUrls: string[]
    ): Promise<any> {
        return new Promise<Blob>((resolve, reject) => {
            const data = {
                fileName: filenameNoExtension,
                dataUrls,
            };
            authorizedAxios(
                "POST",
                `/services/gps/Print/ImageDataUrlsToPdf`,
                {},
                data,
                "blob"
            )
                .then((file: any) => {
                    saveAs(file, `${filenameNoExtension}.pdf`);
                    resolve(file);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    }

    public PdfNewTab(
        product: string,
        jobId: string,
        dataUrls: string[]
    ): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const data = {
                product,
                jobId,
                dataUrls,
            };
            authorizedAxios("POST", `/services/gps/Print/PdfNewTab`, {}, data)
                .then((response: IPdfNewTabResponse) => {
                    resolve(response.url);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    }

    public PdfLambda(
        allImages: IPdfHtmlData[],
    ): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const data = {
                htmlPage: allImages,
            };

            authorizedAxios("POST", `/services/gps/Print/SendToPdfLambda`, {}, data)
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    }
}
